var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-tab-wrap",class:{
    'search-tab-wrap--active': _vm.isActive
  }},[_c('div',{staticClass:"search-tab",class:{
      'search-tab--active': _vm.isActive,
      'search-tab--inactive': _vm.isInactive,
    },attrs:{"role":"button"},on:{"click":_vm.setActiveTab}},[_c('span',{staticClass:"search-tab__text"},[_vm._t("default"),_vm._v(" "),(_vm.hasSelectedItems)?_c('span',{staticClass:"search-tab__text-number"},[_vm._v(_vm._s(_vm.numberOfSelectedItems))]):_vm._e()],2),_vm._v(" "),(_vm.isActive)?_c('icon',{attrs:{"link":"","type":"angle-up"}}):_c('icon',{attrs:{"link":"","type":"angle-down"}})],1),_vm._v(" "),_c('portal-target',{attrs:{"name":_vm.portalName}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d826135","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Search/SearchTab.vue
// module id = 643
// module chunks = 1